import React, { useEffect } from 'react'
import { FormControl, InputLabel, NativeSelect } from '@mui/material'

function InputSelect({ compulsoryData, groupLabel, groupped, label, name, onChange, optionLabel, optionValue, options, value }) {
	return (<FormControl fullWidth>
		<InputLabel
			htmlFor="grouped-select"
			variant="standard"
		>
			{compulsoryData && compulsoryData.indexOf(name) != -1 ? `${label} *` : label}
		</InputLabel>
		<NativeSelect
			fullWidth
			value={value}
			onChange={onChange}
			name={name}
		>
			<option value=""></option>
			{groupped && options.map((group, g) => <optgroup key={g} label={groupLabel(group)}>
				{group.provinces.map((option, o) => <option key={o} value={optionValue(option)}>{optionLabel(option)}</option>)}
			</optgroup>)}

			{!groupped && options.map((option, o) => <option key={o} value={optionValue(option)}>{optionLabel(option)}</option>)}
		</NativeSelect>
	</FormControl>)
}

export default InputSelect
